// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"4585175a","455":"660d45a1","977":"ff42d0f9"}[chunkId] + ".chunk.js";
};